// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","180":"story"}[chunkId] + "-" + {"93":"a673b84bef5d8895e372","180":"52670d70662b10d05c62"}[chunkId] + ".css";
};